import { Typography } from "@material-tailwind/react";
import React, { useState, ChangeEvent } from "react";
import ImageUpload from "../../components/booking/ImageUpload";
import NextBack from "../../components/booking/NextBack";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { useMutation } from "react-query";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";

import { BoatService } from "../../services/boatService";
import { toast } from "react-toastify";
interface ImagePreview {
  file: File | null;
  preview: string | null;
}

const Photos: React.FC = () => {
  const [imagePreviews, setImagePreviews] = useState<
    Record<string, ImagePreview>
  >({
    FrontImage: { file: null, preview: null },
    BackImage: { file: null, preview: null },
    InteriorImage: { file: null, preview: null },
    ExteriorImage: { file: null, preview: null },
    SeaViewImage: { file: null, preview: null },
  });
  const { setStepNumber, setOnBoardingPage, setTab } = useOnboardingStore();
  const onSubmit = () => {
    const formData = new FormData();

    console.log(BoatService.getCurrentBoatId);
    const boatId = BoatService.getCurrentBoatId;
    if (boatId !== null) formData.append("BoatId", boatId);
    formData.append("SideImage", imagePreviews["FrontImage"].file!);
    Object.entries(imagePreviews).forEach(([name, file]) => {
      if (file !== null) formData.append(name, imagePreviews[name].file!);
    });
    photoMutations.mutate(formData);
    for (const [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}:`, {
          // name: value.name,
          size: value.size,
          // type: value.type,
        });
      } else {
        console.log(`${key}:`);
      }
    }
  };

  const photoMutations = useMutation(
    (data: FormData) =>
      api.post(ApiRoutes.uploadBoatImages, data, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    {
      onSuccess: () => {
        setStepNumber(5);
        setOnBoardingPage("Pricing");
        setTab("Pricing");
      },
    }
  );

  const handleImageChange =
    (label: string) => (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          setImagePreviews((prev) => ({
            ...prev,
            [label]: { file, preview: reader.result as string },
          }));
        };

        reader.readAsDataURL(file);
      }
    };

  return (
    <div className="p-4">
      <div className="w-full">
        <Typography
          placeholder={undefined}
          className="text-center mb-6 font-medium text-2xl"
        >
          Upload photos of your boat
        </Typography>
        <div className="flex justify-center">
          <div className="md:w-3/5 md:mx-11 w-full  place-self-center">
            <ImageUpload
              label="Sea View"
              onChange={handleImageChange("SeaViewImage")}
              preview={imagePreviews["SeaViewImage"].preview}
              height="15rem"
            />
          </div>
        </div>
        <div className="justify-center md:flex pt-5">
          <ImageUpload
            label="Front View"
            onChange={handleImageChange("FrontImage")}
            preview={imagePreviews["FrontImage"].preview}
          />
          <ImageUpload
            label="Back View"
            onChange={handleImageChange("BackImage")}
            preview={imagePreviews["BackImage"].preview}
          />
          <ImageUpload
            label="Interior View"
            onChange={handleImageChange("InteriorImage")}
            preview={imagePreviews["InteriorImage"].preview}
          />
          <ImageUpload
            label="Exterior View"
            onChange={handleImageChange("ExteriorImage")}
            preview={imagePreviews["ExteriorImage"].preview}
          />
        </div>
        <NextBack
          isLoading={photoMutations.isLoading}
          next={() => onSubmit()}
          shouldGoNext={
            !Object.values(imagePreviews).some(
              ({ file, preview }) => file === null || preview === null
            )
          }
          back={() => {
            toast.error("Cannot go back on this page");
          }}
          shouldGoBack={false}
        />
      </div>
    </div>
  );
};

export default Photos;
